/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable id-blacklist */
/* eslint-disable no-underscore-dangle */
import {
  Component,
  ElementRef,
  ViewChild,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  FormModelControl,
  InputWithListModel,
  SelectOption,
  SnackbarService,
  toIso8601String,
} from '@bcl/design-system';
import { environment } from 'src/environments';
import {
  ActionEdit,
  ActionType,
  HoursQuarters,
  InputTimeValue,
  Photo,
  toInputTimeValue,
} from './action.model';
import { AttachmentsService } from 'src/app/services/attachments.service';
import { Lightbox } from 'ngx-lightbox';
import { combineLatest, Subject, takeUntil, Subscription } from 'rxjs';
import { HttpEventType } from '@angular/common/http';
import { ActionPointDictionariesService } from './action-dictionaries.service';
import {
  ActionApiService,
  CreateActionDto,
  UpdateActionDto,
} from './action.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentUserService, IUser } from '@ews/users-management';
import { Platform } from '@ionic/angular';
import { CameraService } from 'src/app/services/camera.service';
import { CameraResultType, ImageOptions } from '@capacitor/camera';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Action } from './action.model';
import { EditImageService } from 'src/app/shared-components/components/edit-image/edit-image.service';
import { switchMap } from 'rxjs/operators';
import { BackButtonService } from 'src/app/services/back-button.service';
import { ActionCommentsService } from './action-comments.service';
import {
  ActionCommentsList,
  ActionCommentsListPageChanged,
} from './action-comments.model';

type ActionForm = Omit<ActionEdit, 'id' | 'deadline'> & {
  deadline: string;
};
type NullableActionProperty<T extends keyof ActionForm> = ActionForm[T] | null;

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.scss'],
})
export class ActionPage implements OnInit, OnDestroy {
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef =
    new ElementRef(null);
  public routerState: any;
  public user: IUser | null = null;
  public loading = true;
  public saving = false;
  public visitId: number;
  public date: string;
  public dayNumber: string;
  public areaId: number;
  public customerId: number;
  public locationId: number;
  public parentObject: string;
  public parentId: number;
  public backUrl = '';
  photosList: Photo[] = [];
  photosAddedList: Photo[] = [];
  photosDeletedList: Photo[] = [];
  photosUpdatedList: Photo[] = [];
  public actionTypeOptions: SelectOption[] = [];
  public assigneeOptions: SelectOption[] = [];
  public statusOptions: SelectOption[] = [];
  public responsibilityOptions: SelectOption[] = [];
  public priorityOptions: SelectOption[] = [];
  public contactOptions: SelectOption[] = [];
  public selectedActionType: ActionType | undefined;
  public environment = environment;
  public form: FormGroup<FormModelControl<ActionForm>>;
  public originalData!: ActionForm;
  public hoursQuarters = HoursQuarters;
  public readonly customerControl: FormControl<
    InputWithListModel<SelectOption<number>>
  >;
  public customerOptions: SelectOption<number>[] = [];

  public readonly locationControl: FormControl<
    InputWithListModel<SelectOption<number>>
  >;
  public locationOptions: SelectOption<number>[] = [];

  public readonly areaControl: FormControl<
    InputWithListModel<SelectOption<number>>
  >;
  public areaOptions: SelectOption<number>[] = [];
  selectedFile: File | null = null;
  public uploading = false;
  public uploaded = false;
  public percentageUploaded = 0;
  public fileSize = 20000000;
  public initialDescription: string | null = null;
  public initialReason: string | null = null;
  public originalAction?: Action;
  public commentsList: ActionCommentsList = { elements: [], totalEntries: 0 };
  public commentsLoading = false;

  public actionPointId?: number;

  private readonly defaultDuration: InputTimeValue = '00:00';

  private readonly destroyed$ = new Subject<void>();

  private backButtonSubscription: Subscription;

  constructor(
    private readonly attachmentsService: AttachmentsService,
    private readonly dictionaryService: ActionPointDictionariesService,
    private readonly actionService: ActionApiService,
    private readonly _lightbox: Lightbox,
    private readonly snackbarService: SnackbarService,
    public readonly sanitizer: DomSanitizer,
    fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly currentUserService: CurrentUserService,
    private readonly router: Router,
    public readonly platform: Platform,
    private readonly cameraService: CameraService,
    private readonly translate: TranslateService,
    private readonly editImageService: EditImageService,
    private readonly backButtonService: BackButtonService,
    private readonly actionCommentsService: ActionCommentsService
  ) {
    this.backButtonSubscription =
      this.platform.backButton.subscribeWithPriority(10, () => {
        this.goBack();
      });

    this.route.params.subscribe((params) => {
      this.routerState = this.router.getCurrentNavigation().extras.state;
      this.visitId = params?.id;
      this.date = params?.date;
      this.dayNumber = params?.dayId;
      this.areaId = this.routerState?.areaId;
      this.customerId = this.routerState?.customerId;
      this.locationId = this.routerState?.locationId;
      this.actionPointId = this.routerState?.actionId;
      this.parentObject = this.routerState?.parentObject;
      this.parentId = this.routerState?.parentId;
      this.backUrl = this.routerState?.backUrl;

      this.currentUserService.user.subscribe((user) => {
        this.user = user;
      });

      combineLatest({
        actionDictionaries: this.dictionaryService.getActionDictionaries(),
        action: this.actionService.getAction(this.actionPointId),
      }).subscribe(async ({ actionDictionaries, action }) => {
        if (actionDictionaries.actionTypes !== null) {
          this.actionTypeOptions = actionDictionaries.actionTypes.map((x) => ({
            value: x.value,
            label: x.defaultTitle,
          }));
        }
        if (actionDictionaries.actionStatuses !== null) {
          this.statusOptions = actionDictionaries.actionStatuses.map((x) => ({
            value: x.value,
            label: x.name,
          }));
        }
        if (actionDictionaries.actionResponsibilities !== null) {
          this.responsibilityOptions =
            actionDictionaries.actionResponsibilities.map((x) => ({
              value: x.value,
              label: x.name,
            }));
        }
        if (actionDictionaries.users !== null) {
          actionDictionaries.users.forEach((user) => {
            this.assigneeOptions.push({
              value: user.id,
              label: user.fullName,
            });
          });
        }
        if (actionDictionaries.actionPriorities !== null) {
          this.priorityOptions = actionDictionaries.actionPriorities.map(
            (x) => ({
              value: x.value,
              label: x.label,
            })
          );
        }
        this.form.controls.type.valueChanges
          .pipe(takeUntil(this.destroyed$))
          .subscribe((type) => {
            this.setSelectedActionType(
              actionDictionaries.actionTypes.find((x) => x.value === type)
            );
            this.form.controls.title.setValue(
              this.selectedActionType?.defaultTitle ?? null
            );
          });

        // Store the original action data including actionNumber
        this.originalAction = action;

        this.form.patchValue({
          assigneeId: action?.assigneeId ?? this.user?.id,
          type: action?.actionTypeId?.toString() ?? null,
          status: action?.statusId?.toString() ?? '0',
          responsibility: action?.responsibilityId?.toString() ?? null,
          title: action?.title ?? this.selectedActionType?.defaultTitle,
          description: action?.description ?? null,
          deadline: toIso8601String(action?.deadline ?? new Date() ?? null),
          deadlineTime: toInputTimeValue(action?.deadlineTime),
          duration: toInputTimeValue(action?.duration ?? this.defaultDuration),
          contactId: action?.contactId?.toString() ?? null,
          finalApprovalBy: action?.finalApprovalBy ?? null,
          finalApprovalDate: action?.finalApprovalDate ?? null,
          reason: action?.reason ?? null,
          priorityId: action?.priorityId?.toString() ?? '0',
        });
        this.initialDescription = action?.description ?? null;
        this.initialReason = action?.reason ?? null;
        this.form.markAsDirty();

        this.photosList = JSON.parse(JSON.stringify(action?.photos ?? []));
        await this.downloadAllPhotos();

        if (this.actionPointId) {
          this.loadComments();
        }

        this.loading = false;
      });
      this.form = fb.group({
        type: [null as NullableActionProperty<'type'>, Validators.required],
        assigneeId: [
          null as NullableActionProperty<'assigneeId'>,
          Validators.required,
        ],
        deadline: [
          null as NullableActionProperty<'deadline'>,
          Validators.required,
        ],
        deadlineTime: null as NullableActionProperty<'deadlineTime'>,
        duration: this.defaultDuration as NullableActionProperty<'duration'>,
        status: ['0' as NullableActionProperty<'status'>, Validators.required],
        responsibility: [
          '1' as NullableActionProperty<'responsibility'>,
          Validators.required,
        ],
        title: [null as NullableActionProperty<'title'>, Validators.required],
        description: null as NullableActionProperty<'description'>,
        contactId: null as NullableActionProperty<'contactId'>,
        initialApprovalBy: null as NullableActionProperty<'initialApprovalBy'>,
        initialApprovalDate:
          null as NullableActionProperty<'initialApprovalDate'>,
        finalApprovalBy: null as NullableActionProperty<'finalApprovalBy'>,
        finalApprovalDate: null as NullableActionProperty<'finalApprovalDate'>,
        reason: [null as NullableActionProperty<'reason'>],
        priorityId: null as NullableActionProperty<'priorityId'>,
      });

      // Note: Status is now read-only, so no validation subscription needed
    });
  }

  public get showReason(): boolean {
    const status = this.form?.get('status')?.value;
    return ['-1', '2', '5'].includes(status);
  }

  public get isEdit(): boolean {
    return this.actionPointId !== undefined;
  }

  public get disabledSubmit(): boolean {
    return !this.form.dirty || !this.form.valid;
  }

  public ngOnInit(): void {
    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.goBack();
      },
    });
  }

  public ionViewWillEnter(): void {
    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.goBack();
      },
    });
  }

  public ngOnDestroy(): void {
    this.photosList.forEach((photo) => {
      if (photo.blobUrl) {
        URL.revokeObjectURL(photo.blobUrl);
      }
    });
    this.photosAddedList.forEach((photo) => {
      if (photo.blobUrl) {
        URL.revokeObjectURL(photo.blobUrl);
      }
    });
    this.photosUpdatedList.forEach((photo) => {
      if (photo.blobUrl) {
        URL.revokeObjectURL(photo.blobUrl);
      }
    });
    this.backButtonSubscription?.unsubscribe();
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  onFileSelected(event: any) {
    this.selectedFile = event;
    if (this.selectedFile) {
      let parentId = 0;

      if (this.actionPointId) {
        parentId = this.actionPointId;
      }
      if (this.selectedFile.size <= this.fileSize) {
        this.uploading = true;
        this.editImageService
          .editImage({ file: this.selectedFile })
          .pipe(
            switchMap((result) => {
              if (!result) {
                // User cancelled the edit dialog
                this.uploading = false;
                this.selectedFile = null;
                return [];
              }
              return this.attachmentsService.saveFile(
                'ActionPoint',
                parentId,
                result.file
              );
            })
          )
          .subscribe({
            next: async (result: any) => {
              if (result.type === HttpEventType.Response) {
                this.uploading = false;
                const newPhoto = {
                  fileName: this.selectedFile?.name ?? '',
                  size: this.selectedFile?.size ?? 0,
                  mimeType: this.selectedFile?.type ?? '',
                  referenceId: result.body.referenceId.toString() ?? '',
                  description: '',
                  type: '19',
                  id: result.body.id ?? 0,
                };
                this.photosList.push(newPhoto);
                this.photosAddedList.push(newPhoto);
                await this.downloadNewPhoto(newPhoto);
                this.form.markAsDirty();
              }
              if (result.type === HttpEventType.UploadProgress) {
                this.percentageUploaded = Math.round(
                  (100 * result.loaded) / result.total
                );
              }
            },
            error: () => {
              this.snackbarService.open(
                'red',
                'ACTIONS_LIST.MESSAGES.ERROR_UPLOADING_PHOTO'
              );
              this.uploading = false;
              this.selectedFile = null;
            },
          });
      } else {
        this.snackbarService.open(
          'red',
          'ACTIONS_LIST.MESSAGES.ERROR_UPLOADING_PHOTO'
        );
        this.uploading = false;
        this.selectedFile = null;
      }
    } else {
      this.uploading = false;
    }
  }
  deletePhoto(photo: Photo) {
    this.photosAddedList = this.photosAddedList.filter(
      (x) => x.referenceId !== photo.referenceId
    );
    this.photosUpdatedList = this.photosUpdatedList.filter(
      (x) => x.referenceId !== photo.referenceId
    );
    this.photosList = this.photosList.filter((x) => x !== photo);
    this.photosDeletedList.push(photo);
    this.form.markAsDirty();
  }
  updatePhoto(photo: Photo) {
    const photoExists = this.photosAddedList.find(
      (x) => x.referenceId === photo.referenceId
    );
    if (!photoExists) {
      this.photosUpdatedList.push(photo);
      this.form.markAsDirty();
    } else {
      photoExists.description = photo.description;
    }
    photo.edited = false;
  }

  public formatBytes(bytes: number) {
    return this.attachmentsService.formatBytes(bytes);
  }

  async takePhoto() {
    const options: ImageOptions = {
      quality: 90,
      resultType: CameraResultType.DataUrl,
      correctOrientation: true,
      allowEditing: false,
      height: 800,
      width: 800,
      saveToGallery: true,
      promptLabelPhoto: this.translate.instant(
        'ACTIONS_LIST.ACTION_POINT_EDIT.LABELS.FROM_GALLERY'
      ),
      promptLabelPicture: this.translate.instant(
        'ACTIONS_LIST.ACTION_POINT_EDIT.LABELS.TAKE_PICTURE'
      ),
      promptLabelHeader: this.translate.instant(
        'ACTIONS_LIST.ACTION_POINT_EDIT.LABELS.PHOTO_HEADER'
      ),
    };

    try {
      const imageData = await this.cameraService.getPhoto(options);

      const response = await fetch(imageData.dataUrl);
      const blob = await response.blob();
      const file = new File([blob], `photo_${Date.now()}.jpg`, {
        type: 'image/jpeg',
      });

      this.onFileSelected(file);
    } catch (error) {
      if (error.message !== 'User cancelled photos app') {
        this.snackbarService.open(
          'red',
          'ACTIONS_LIST.MESSAGES.ERROR_TAKING_PHOTO'
        );
      }
    }
  }

  openLightbox(id: number): void {
    const photos = this.photosList.map((photo) => ({
      src:
        photo.blobUrl ||
        this.sanitizer
          .bypassSecurityTrustUrl(
            `${this.environment.apiHost}/files/${photo.referenceId}`
          )
          .toString(),
      caption: photo.fileName,
      thumb:
        photo.blobUrl ||
        this.sanitizer
          .bypassSecurityTrustUrl(
            `${this.environment.apiHost}/files/${photo.referenceId}`
          )
          .toString(),
    }));
    this._lightbox.open(photos, id);
  }

  public applyChange(): void {
    this.saving = true;
    const change = this.form.value;
    if (this.actionPointId.toString() === '0') {
      const dto: CreateActionDto = {
        number: '', // For new actions, use empty string or generate
        actionTypeID: change.type,
        statusID: change.status,
        responsibilityID: change.responsibility,
        parentObject: this.parentObject,
        parentID: this.parentId,
        deadline: toIso8601String(change.deadline),
        deadlineTime: change.deadlineTime,
        duration: change.duration,
        title: this.selectedActionType?.defaultTitle || '', // Use default title from action type
        description: change.description,
        assigneeID: change.assigneeId,
        extended: true,
        customerID: this.customerId,
        locationID: this.locationId,
        areaID: this.areaId,
        contactId: this.originalAction?.contactId || null, // Use original contact if available
        initialApprovalBy: change.initialApprovalBy,
        initialApprovalDate: change.initialApprovalDate,
        finalApprovalBy: change.finalApprovalBy,
        finalApprovalDate: change.finalApprovalDate,
        reason: change.reason,
        priorityId: change.priorityId,
        mapX: this.parentObject === 'PC.Detection' ? 0 : undefined,
        mapY: this.parentObject === 'PC.Detection' ? 0 : undefined,
      };

      this.actionService.createAction(dto).subscribe({
        next: (newActionPoint) => {
          this.actionPointId = newActionPoint.id;

          let totalOperations = 0;
          let completedOperations = 0;

          // Count all operations first
          if (this.photosAddedList && this.photosAddedList.length > 0) {
            totalOperations += this.photosAddedList.length;
          }
          if (this.photosDeletedList && this.photosDeletedList.length > 0) {
            totalOperations += this.photosDeletedList.length;
          }

          const checkCompletion = () => {
            if (completedOperations === totalOperations) {
              this.photosAddedList = [];
              this.photosDeletedList = [];
              this.saving = false;
            }
          };

          // Start operations after counting
          if (this.photosAddedList && this.photosAddedList.length > 0) {
            this.photosAddedList.forEach((photo, index) => {
              this.attachmentsService
                .newAttachment({
                  parentObject: 'ActionPoint',
                  parentID: newActionPoint.id.toString(),
                  fileName: photo.fileName,
                  description: photo.description,
                  size: photo.size,
                  createdBy: this.user?.id,
                  type: 0,
                  mimeType: photo.mimeType,
                  referenceId: photo.referenceId,
                  customerShare: false,
                  restricted: false,
                })
                .subscribe({
                  next: () => {
                    completedOperations++;
                    checkCompletion();
                  },
                  error: () => {
                    this.saving = false;
                  },
                });
            });
          }

          if (this.photosDeletedList && this.photosDeletedList.length > 0) {
            this.photosDeletedList.forEach((photo, index) => {
              this.attachmentsService
                .deleteAttachment(photo.referenceId, null)
                .subscribe({
                  next: () => {
                    completedOperations++;
                    checkCompletion();
                  },
                  error: () => {
                    this.saving = false;
                  },
                });
            });
          }

          if (totalOperations === 0) {
            this.saving = false;
            this.snackbarService.open(
              'green',
              'ACTIONS_LIST.MESSAGES.ACTION_ADDED'
            );
            setTimeout(() => {
              this.goBack();
            }, 1000);
          }
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'ACTIONS_LIST.MESSAGES.ERROR_ADDING_ACTION'
          );
          this.saving = false;
        },
      });
    } else if (this.actionPointId.toString() > '0') {
      const dto: UpdateActionDto = {
        id: this.actionPointId,
        number: this.originalAction?.['number'] ?? '',
        actionTypeID: change.type,
        statusID: change.status,
        responsibilityID: change.responsibility,
        deadline: toIso8601String(change.deadline),
        deadlineTime: change.deadlineTime,
        duration: change.duration,
        title:
          this.originalAction?.title ??
          this.selectedActionType?.defaultTitle ??
          '', // Keep original title
        description: change.description,
        assigneeID: change.assigneeId,
        extended: true,
        customerID: this.customerId,
        locationID: this.locationId,
        areaID: this.areaId,
        contactId: this.originalAction?.contactId ?? null, // Keep original contact
        initialApprovalBy: change.initialApprovalBy,
        initialApprovalDate: change.initialApprovalDate,
        finalApprovalBy: change.finalApprovalBy,
        finalApprovalDate: change.finalApprovalDate,
        reason: change.reason,
        priorityId: change.priorityId,
      };
      this.actionService.updateAction(dto).subscribe({
        next: () => {
          let totalOperations = 0;
          let completedOperations = 0;

          // Count all operations first
          if (this.photosAddedList && this.photosAddedList.length > 0) {
            totalOperations += this.photosAddedList.length;
          }
          if (this.photosDeletedList && this.photosDeletedList.length > 0) {
            totalOperations += this.photosDeletedList.length;
          }
          if (this.photosUpdatedList && this.photosUpdatedList.length > 0) {
            totalOperations += this.photosUpdatedList.length;
          }

          const checkCompletion = () => {
            if (completedOperations === totalOperations) {
              this.photosAddedList = [];
              this.photosDeletedList = [];
              this.photosUpdatedList = [];
              this.saving = false;
              this.snackbarService.open(
                'green',
                'ACTIONS_LIST.MESSAGES.ACTION_UPDATED'
              );
              setTimeout(() => {
                this.goBack();
              }, 1000);
            }
          };

          // Start operations after counting
          if (this.photosAddedList && this.photosAddedList.length > 0) {
            this.photosAddedList.forEach((photo, index) => {
              this.attachmentsService
                .newAttachment({
                  parentObject: 'ActionPoint',
                  parentID: this.actionPointId.toString(),
                  fileName: photo.fileName,
                  description: photo.description,
                  size: photo.size,
                  createdBy: this.user?.id,
                  type: 0,
                  mimeType: photo.mimeType,
                  referenceId: photo.referenceId,
                  customerShare: false,
                  restricted: false,
                })
                .subscribe({
                  next: () => {
                    completedOperations++;
                    checkCompletion();
                  },
                  error: () => {
                    this.saving = false;
                  },
                });
            });
          }

          if (this.photosDeletedList && this.photosDeletedList.length > 0) {
            this.photosDeletedList.forEach((photo, index) => {
              this.attachmentsService
                .deleteAttachment(photo.referenceId, photo.id ?? null)
                .subscribe({
                  next: () => {
                    completedOperations++;
                    checkCompletion();
                  },
                  error: () => {
                    this.saving = false;
                  },
                });
            });
          }

          if (this.photosUpdatedList && this.photosUpdatedList.length > 0) {
            this.photosUpdatedList.forEach((photo, index) => {
              this.attachmentsService
                .updateAttachment({
                  id: photo.id,
                  description: photo.description,
                  type: 19,
                  customerShare: false,
                  restricted: false,
                })
                .subscribe({
                  next: () => {
                    completedOperations++;
                    checkCompletion();
                  },
                  error: () => {
                    this.saving = false;
                  },
                });
            });
          }

          if (totalOperations === 0) {
            this.saving = false;
            this.snackbarService.open(
              'green',
              'ACTIONS_LIST.MESSAGES.ACTION_UPDATED'
            );
            setTimeout(() => {
              this.goBack();
            }, 1000);
          }
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'ACTIONS_LIST.MESSAGES.ERROR_UPDATING_ACTION'
          );
          this.saving = false;
        },
      });
    }
  }
  public goBack(): void {
    if (this.routerState?.backUrl.includes('area/map')) {
      this.router.navigateByUrl(`${this.backUrl}`);
    } else {
      this.router
        .navigateByUrl('/notes', { skipLocationChange: true })
        .then(() => {
          this.router.navigateByUrl(`${this.backUrl}`);
        });
    }
  }
  public setDesc(desc: string) {
    this.form.get('description')?.setValue(desc);
    this.form.markAsDirty();
  }
  public setReason(reason: string) {
    this.form.get('reason')?.setValue(reason);
    this.form.markAsDirty();
  }
  public approveEWS(): void {
    const now = new Date();
    const localDateTime = now
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
      .replace(' ', 'T');

    this.form.patchValue({
      finalApprovalBy: this.user?.id,
      status: '1',
      finalApprovalDate: localDateTime,
    });
    this.applyChange();
  }

  public loadComments(): void {
    if (!this.actionPointId) {
      return;
    }

    this.commentsLoading = true;
    this.actionCommentsService
      .getActionComments({
        parentID: this.actionPointId,
        pageNumber: 1,
        pageSize: 5,
      })
      .subscribe({
        next: (comments) => {
          this.commentsList = comments;
          this.commentsLoading = false;
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'ACTIONS_LIST.ACTION_POINT_EDIT.COMMENTS.ERROR_LOADING'
          );
          this.commentsLoading = false;
        },
      });
  }

  public loadMoreComments(page: ActionCommentsListPageChanged): void {
    if (!this.actionPointId) {
      return;
    }

    this.commentsLoading = true;
    this.actionCommentsService
      .getActionComments({
        parentID: this.actionPointId,
        pageNumber: page.pageNumber,
        pageSize: page.pageSize,
      })
      .subscribe({
        next: (comments) => {
          this.commentsList = {
            ...comments,
            elements: [...this.commentsList.elements, ...comments.elements],
          };
          this.commentsLoading = false;
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'ACTIONS_LIST.ACTION_POINT_EDIT.COMMENTS.ERROR_LOADING'
          );
          this.commentsLoading = false;
        },
      });
  }

  private setSelectedActionType(type: ActionType | undefined): void {
    this.selectedActionType = type;
  }

  private async downloadPhoto(photo: Photo): Promise<void> {
    try {
      const response = await fetch(
        `${this.environment.apiHost}/files/${photo.referenceId}`,
        {
          headers: {
            accept: 'application/octet-stream',
          },
        }
      );
      if (!response.ok) {
        throw new Error('Failed to download photo');
      }
      const blob = await response.blob();
      if (photo.blobUrl) {
        URL.revokeObjectURL(photo.blobUrl);
      }
      const blobUrl = URL.createObjectURL(blob);
      photo.blobUrl = this.sanitizer.bypassSecurityTrustUrl(blobUrl) as string;
    } catch (error) {
      console.error('Error downloading photo:', error);
      this.snackbarService.open(
        'red',
        'ACTIONS_LIST.MESSAGES.ERROR_DOWNLOADING_PHOTO'
      );
    }
  }

  private async downloadAllPhotos(): Promise<void> {
    const downloadPromises = this.photosList.map((photo) =>
      this.downloadPhoto(photo)
    );
    await Promise.all(downloadPromises);
  }

  private async downloadNewPhoto(photo: Photo): Promise<void> {
    await this.downloadPhoto(photo);
  }
}
